import styles from './sponsoringDisplay.module.css';
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import sponsoring from '../../../config/sponsoring';// Adjust the path
import { getFooterBackground } from '../../../code/ColorHandler';
function SponsoringDisplay() {
    const navigate = useNavigate();
    const location = useLocation();
    const footerBackground = getFooterBackground(location);
    const handleClick = (link) => {
        if (link) {
            window.open(link, "_blank");
        } else {
            toast.info("Dieser Sponsor hat keinen Link.");
        }
    };
    const renderSponsors = (sponsors, isPremium) =>
        sponsors.map((sponsor, index) => {
            const imagePath = `/uploads/sponsoren/${sponsor.img}`;

            return (
                <div
                    key={index}
                    className={`${styles.sponsor} ${isPremium ? styles.premiumSponsor : ""}`}
                    onClick={() => handleClick(sponsor.link)}
                    role="button"
                    tabIndex={0}
                >
                    <img
                        src={imagePath}
                        alt={sponsor.name}
                        className={styles.sponsorImage}
                    />
                </div>
            );
        });
    return (
        <div className={styles.sponsorFooter}
            style={{ backgroundColor: footerBackground }}
        >
            <h2>Wir bedanken uns vielmals bei all unseren Sponsoren!</h2>
            <h3>Unsere Premium Sponsoren</h3>
            <div className={styles.sponsorRow}>{renderSponsors(sponsoring.premium, true)}</div>

            <button
                className={styles.moreSponsorsButton}
                onClick={() => navigate("/sponsoren")}
            >
                Weitere Sponsoren anzeigen
            </button>

        </div>
    );
}
export default SponsoringDisplay